import React from 'react';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  Button,
  Col,
  Form,
  Modal,
  Row,
  Tab,
  Table,
  Tabs,
} from 'react-bootstrap';
import { TimesheetAddIcon } from 'assets/images/TimesheetAddIcon/TimesheetAddIcon';
import { TimesheetDeleteIcon } from 'assets/images/TimesheetDeleteIcon/TimesheetDeleteIcon';
import { MaximizeIcon } from 'assets/images/MaximizeIcon/MaximizeIcon';
import { MinimizeIcon } from 'assets/images/MinimizeIcon/MinimizeIcon';
import { setTimesheetDetail } from 'store/slices/timesheet/timesheetDetailSlice';
import TimesheetPolineSection from '../FormComponents/TimesheetPolineSection';
import { BuPath } from 'constants/buPath';

import {
  displayError,
  displaySuccess,
} from 'components/common/Alert/ToastAlert';

const TimesheetActivities = props => {
  const {
    timesheetActivities,
    timesheetPOLines,
    canEditActivity,
    bucketPOEnabled,
  } = props;
  const dispatch = useDispatch();
  const purchaseOrder = useSelector(state => state.purchaseOrderDetails);
  const timesheet = useSelector(state => state.timesheetDetail);
  const [expandActivities, setExpandActivities] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [enabledDeleteButtons, setEnabledDeleteButtons] = useState({});

  let totalSum = 0;
  for (let i = 0; i < timesheetActivities.length; i++) {
    totalSum += timesheetActivities[i].lineAmount;
  }

  const toggleActivity = activityNum => {
    if (expandActivities.includes(activityNum)) {
      setExpandActivities(expandActivities.filter(id => id !== activityNum));
    } else {
      setExpandActivities([...expandActivities, activityNum]);
    }
  };

  const handleCheckboxChange = (activityNum, index, checked) => {
    const updated = { ...selectedCheckboxes };
    if (!updated[activityNum]) updated[activityNum] = [];
    if (checked) {
      updated[activityNum].push(index);
    } else {
      updated[activityNum] = updated[activityNum].filter(i => i !== index);
    }
    setSelectedCheckboxes(updated);
    setEnabledDeleteButtons(prev => ({
      ...prev,
      [activityNum]: updated[activityNum].length > 0,
    }));
  };

  const handleDeleteRows = activityNum => {
    let updatedTimesheet = _.cloneDeep(timesheet);
    const selectedIndexes = selectedCheckboxes[activityNum] || [];

    // Get all rows for this activityNum
    const rowsForActivity = updatedTimesheet.timesheetAccounts.filter(
      item => item.activitynum === activityNum,
    );

    // Prevent deletion if only one row is left
    if (
      rowsForActivity.length <= 1 ||
      selectedIndexes.length >= rowsForActivity.length
    ) {
      displayError('At least one line must be present for this activity.');
      return;
    }

    let count = -1;
    updatedTimesheet.timesheetAccounts =
      updatedTimesheet.timesheetAccounts.filter(item => {
        if (item.activitynum !== activityNum) return true;
        count++;
        return !selectedIndexes.includes(count);
      });

    const updatedAccounts = updateTimesheetAccounts(
      timesheetActivities,
      updatedTimesheet.timesheetAccounts,
    );

    updatedTimesheet['timesheetAccounts'] = updatedAccounts;
    dispatch(setTimesheetDetail(updatedTimesheet));
    setSelectedCheckboxes(prev => ({ ...prev, [activityNum]: [] }));
    setEnabledDeleteButtons(prev => ({ ...prev, [activityNum]: false }));
  };
  function updateTimesheetAccounts(timesheetActivities, timesheetAccounts) {
    // Group accounts by activitynum

    const activityNumCount = timesheetAccounts.reduce((acc, account) => {
      acc[account.activitynum] = (acc[account.activitynum] || 0) + 1;

      return acc;
    }, {});

    // Build a lookup for lineAmount by activitynum from activities

    const activityMap = timesheetActivities.reduce((map, activity) => {
      map[activity.activitynum] = activity.lineAmount;

      return map;
    }, {});

    // Update logic

    return timesheetAccounts.map(account => {
      const activitynum = account.activitynum;

      const isOnlyOneAccount = activityNumCount[activitynum] === 1;

      const updatedAccount = { ...account };

      if (isOnlyOneAccount && activityMap[activitynum] !== undefined) {
        updatedAccount.lineAmount = activityMap[activitynum];

        updatedAccount.percentage = '100';
      }

      return updatedAccount;
    });
  }

  const handleAddRow = activitynum => {
    const poLineDetails = purchaseOrder.costActivities?.filter(
      obj => String(obj.activitynum) === String(activitynum),
    );
    let updatedTimesheet = _.cloneDeep(timesheet);
    let timeSheetAccountsObj = {
      activitynum: activitynum,
      polinenum: poLineDetails[0].polinenum,
      glbu: ' ',
      dept: ' ',
      accountNmbr: null,
      workorder: ' ',
      projectBusinessUnit: ' ',
      abmsProject: ' ',
      abmsActivity: ' ',
      costComponent: ' ',
      statejuris: ' ',
      productcode: ' ',
      resourcesubcategory: ' ',
      percentage: 0,
      lineAmount: 0,
    };

    // let findIndexOfActivity = updatedTimesheet.timesheetAccounts.findIndex(
    //   item => item.activitynum === activitynum,
    // );

    updatedTimesheet.timesheetAccounts.push(timeSheetAccountsObj);

    dispatch(setTimesheetDetail(updatedTimesheet));
  };

  const getAllDistibutedLines = activityNum => {
    // debugger;
    return timesheetPOLines?.filter(item => item.activitynum === activityNum);
  };

  return (
    <>
      <div className="aepContainer">
        {' '}
        {timesheetActivities &&
          timesheetActivities.length > 0 &&
          timesheetActivities.map(activities => {
            const isDeleteEnabled =
              enabledDeleteButtons[activities.activitynum] || false;

            return (
              <div className="accountingHeader" key={activities.activitynum}>
                <Row style={{ width: '100%' }}>
                  <Col sm={1} style={{ marginLeft: '10px' }}>
                    <Form.Group>
                      <Form.Label>POline:</Form.Label>
                      <Form.Control
                        className="customSelect"
                        value={activities.polinenum}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={2} style={{ marginLeft: '20px' }}>
                    <Form.Group>
                      <Form.Label>Activity / SOV No:</Form.Label>
                      <Form.Control
                        className="customSelect"
                        value={activities.activitynum}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={3}>
                    <Form.Group>
                      <Form.Label>Description:</Form.Label>
                      <Form.Control
                        className="customSelect"
                        value={activities.description}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={1}>
                    <Form.Group>
                      <Form.Label>Amount ($):</Form.Label>
                      <Form.Control
                        className="customSelect"
                        value={Number(activities.lineAmount).toFixed(2)}
                        disabled
                      />
                    </Form.Group>
                  </Col>

                  <Col
                    sm={4}
                    style={{ display: 'flex', justifyContent: 'flex-start' }}
                  >
                    <>
                      <div
                        className={
                          expandActivities.includes(activities.activitynum) &&
                          !bucketPOEnabled
                            ? 'deleteIconEnabledTimesheet'
                            : 'deleteIconDisabledTimesheet'
                        }
                        onClick={() => handleAddRow(activities.activitynum)}
                      >
                        <TimesheetAddIcon />
                      </div>

                      <div
                        className={
                          isDeleteEnabled
                            ? 'deleteIconEnabledTimesheet'
                            : 'deleteIconDisabledTimesheet'
                        }
                        onClick={() => {
                          if (isDeleteEnabled) {
                            handleDeleteRows(activities.activitynum);
                          }
                        }}
                      >
                        <TimesheetDeleteIcon />
                      </div>
                    </>

                    <div className="minMaxTimesheet">
                      {expandActivities.includes(activities.activitynum) ? (
                        <div
                          onClick={() => toggleActivity(activities.activitynum)}
                        >
                          <MinimizeIcon />
                        </div>
                      ) : (
                        <div
                          onClick={() => toggleActivity(activities.activitynum)}
                        >
                          <MaximizeIcon />
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                {expandActivities.includes(activities.activitynum) && (
                  <TimesheetPolineSection
                    timesheetDistributedLines={getAllDistibutedLines(
                      activities.activitynum,
                    )}
                    activityAmount={activities.lineAmount}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedCheckboxes={
                      selectedCheckboxes[activities.activitynum] || []
                    }
                    canEditActivity={canEditActivity}
                    bucketPOEnabled={bucketPOEnabled}
                  />
                )}
              </div>
            );
          })}
        <div>
          <Row>
            <Col sm={6} />
            <Col sm={1} style={{ width: '15% !important', margin: '30px' }}>
              <Form.Group>
                <Form.Label>Grand Total ($) </Form.Label>
                <Form.Control
                  className="customSelect"
                  value={Number(totalSum).toFixed(2)}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default TimesheetActivities;
